<app-loading-skeleton
  class="self-start w-[220px] h-[52px]"
  viewBox="0 0 220 52"
  [preserveAspectRatio]="false"
  backgroundTextClass="text-background-fixed"
>
  <svg:rect x="0" y="0" rx="12" ry="12" width="100%" height="100%" />
</app-loading-skeleton>

<app-loading-skeleton
  class="self-end w-[120px] h-[36px]"
  viewBox="0 0 120 36"
  [preserveAspectRatio]="false"
  backgroundTextClass="text-background-fixed"
>
  <svg:rect x="0" y="0" rx="12" ry="12" width="100%" height="100%" />
</app-loading-skeleton>

<app-loading-skeleton
  class="self-start w-[180px] h-[36px]"
  viewBox="0 0 180 36"
  [preserveAspectRatio]="false"
  backgroundTextClass="text-background-fixed"
>
  <svg:rect x="0" y="0" rx="12" ry="12" width="100%" height="100%" />
</app-loading-skeleton>

<app-loading-skeleton
  class="self-start w-[240px] h-[68px]"
  viewBox="0 0 240 68"
  [preserveAspectRatio]="false"
  backgroundTextClass="text-background-fixed"
>
  <svg:rect x="0" y="0" rx="12" ry="12" width="100%" height="100%" />
</app-loading-skeleton>

<app-loading-skeleton
  class="self-end w-[160px] h-[36px]"
  viewBox="0 0 160 36"
  [preserveAspectRatio]="false"
  backgroundTextClass="text-background-fixed"
>
  <svg:rect x="0" y="0" rx="12" ry="12" width="100%" height="100%" />
</app-loading-skeleton>
